module.exports = __webpack_public_path__ + "img/commerce-3.1481b425.jpg";